import React from 'react'

const TOULogoTitle = () => {
  return (
    <svg
      width="50"
      height="17"
      viewBox="0 0 50 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50 9.95856C50 12.0049 49.3427 13.5651 48.0279 14.639C46.7132 15.713 44.8445 16.25 42.4219 16.25C39.9993 16.25 38.1232 15.713 36.7938 14.639C35.479 13.5651 34.8217 12.0049 34.8217 9.95856V1.01123H39.7186V9.89325C39.7186 10.735 39.9476 11.4099 40.4055 11.9178C40.8635 12.4113 41.5282 12.658 42.3998 12.658C43.2713 12.658 43.9361 12.404 44.394 11.8961C44.8667 11.3881 45.1031 10.7205 45.1031 9.89325V1.01123H50V9.95856Z"
        fill="#3B564B"
      />
      <path
        d="M23.9419 0.75C26.5713 0.75 28.6025 1.41035 30.0353 2.73104C31.4682 4.05173 32.1847 5.97472 32.1847 8.5C32.1847 11.0253 31.4682 12.9483 30.0353 14.269C28.6025 15.5897 26.5713 16.25 23.9419 16.25C21.3124 16.25 19.2813 15.5969 17.8484 14.2907C16.4303 12.97 15.7212 11.0398 15.7212 8.5C15.7212 5.96021 16.4303 4.03722 17.8484 2.73104C19.2813 1.41035 21.3124 0.75 23.9419 0.75ZM23.9419 4.34199C22.893 4.34199 22.0953 4.65403 21.5488 5.27809C21.0022 5.90215 20.7289 6.74391 20.7289 7.80337V9.19663C20.7289 10.2561 21.0022 11.0978 21.5488 11.7219C22.0953 12.346 22.893 12.658 23.9419 12.658C24.9907 12.658 25.7884 12.346 26.3349 11.7219C26.8963 11.0978 27.1769 10.2561 27.1769 9.19663V7.80337C27.1769 6.74391 26.8963 5.90215 26.3349 5.27809C25.7884 4.65403 24.9907 4.34199 23.9419 4.34199Z"
        fill="#3B564B"
      />
      <path
        d="M9.90469 4.84269V15.9888H5.00774V4.84269H0V1.01123H14.8903V4.84269H9.90469Z"
        fill="#3B564B"
      />
    </svg>
  )
}

export default TOULogoTitle
